<template>
  <div>
    <b-card no-body class="my-2">
      <b-card-header class="card-header-results border-0">
        <div class="d-sm-flex align-items-center">
          <b-button-group class="mr-3">
            <b-button variant="info" @click="toggleCollapse()" size="sm" v-b-tooltip.hover
              :title="collapsed ? $gettext('Collapse') : $gettext('Expand') ">
              <b-icon :icon="collapsed ? 'dash' : 'plus'" />
            </b-button>
            <b-button variant="primary" @click="$emit('info')" size="sm" v-b-tooltip.hover :title="$gettext('Info')">
              <b-icon icon="info-circle-fill" />
            </b-button>
            <b-button variant="danger" @click="$emit('toggle')" size="sm" v-b-tooltip.hover title="PDF">
              <b-iconstack>
                <b-icon icon="square" scale="0.8" stacked />
                <b-icon icon="check" v-if="selected" scale="0.7" stacked />
              </b-iconstack>
            </b-button>
          </b-button-group>
          <div class="card-header-result-name" :id="'result' + result.id">
            <span style="font-size:16px;">
              <strong class="mr-2 text-primary " @click="toggleCollapse()">{{result.name}}</strong>
              <sup class="text-warning" v-if="starsIsNumber">
                <span v-for="star in result.stars" :key="star">
                  <img src="@/assets/images/icons/star.svg" alt="" class="star">
                </span>
              </sup>
              <span v-else class="text-warning">{{ result.stars }}</span>
            </span>
            <h6 class="text-primary d-inline ml-2"><small>{{result.extraStars}}</small></h6>
          </div>
        </div>
        <div class="price-and-status">
          <span v-if="status =='AVL'" class="FCAVL">{{ status }}</span>
          <span v-if="status =='RQ'" class="RQNA">{{ status }}</span>
          <span v-if="status =='N/A'" class="RQNA">{{ status }}</span>
          <span class="price-start-at">
            <translate>from</translate>: {{ getFullPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{
            params.currency }}
          </span>
          <span class="price-off" v-if="displayedMeal.discount">
            <translate>sale</translate>: {{ getPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{
            params.currency }}
          </span>

        </div>
      </b-card-header>
      <b-card-body v-if="collapsed">
        <div class="row mb-5">
          <div class="col-md-4">
            <div class="card">
              <b-carousel id="carousel" controls indicators background="#FFF" v-if="result.images.length">
                <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img" />
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <template v-else>
                <img :src="result.image.url" v-if="result.image" class="img-thumbnail shadow" />
                <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-thumbnail shadow" />
              </template>
            </div>
          </div>
          <div class="col-md-8 align-self-center">
            <h5 class="text-left">
              <span class="mr-2">{{result.name}}</span>
              <sup class="text-warning" v-if="starsIsNumber">
                <span v-for="star in result.stars" :key="star">
                  <img src="@/assets/images/icons/star.svg" alt="" class="star">
                </span>
              </sup>
              <span v-else class="text-warning">{{ result.stars }}</span>
            </h5>
            <p style="white-space: pre-line;" v-if="result.isInhouse || result.isEtripHotels">{{ result.description }}</p>
            <p style="white-space: pre-line;" v-if="!result.isInhouse && !result.isEtripHotels" v-html="result.description"></p>
            <template v-if="result.url">
              <small class="display-block">
                <a :href="result.url" target="_blank">{{ result.url }}</a>
              </small>
            </template>
          </div>
        </div>
        <!-- slot insert room type and meal table -->
        <slot></slot>
      </b-card-body>
    </b-card>
    <b-modal v-model="modal" title="Modal Info" size="xl" hide-header hide-footer centered id="lightbox">
      <b-row>
        <b-col class="mx-auto" md="8">
          <div class="d-flex justify-content-end mb-3">
            <b-button class="btn btn-dark btn-sm btn-lightbox" @click="close" v-b-tooltip.hover title="Close">
              <b-icon icon="x" />
            </b-button>
          </div>
          <b-card no-body>
            <b-carousel id="carousel" controls indicators background="#FFF" v-if="result.images.length">
              <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
                <template slot="img">
                  <img :src="image" class="img-fluid w-100 d-block carousel-img" />
                </template>
              </b-carousel-slide>
            </b-carousel>
            <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'

export default {
  name: 'SearchResult',
  props: {
    params: Object,
    result: Object,
    selected: Boolean,
    expanded: Boolean,
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data () {
    return {
      collapsed: this.expanded,
      modal: false
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice,
    getPrice,
    close () {
      this.modal = false
    },
    open () {
      this.modal = true
    }
  },
  computed: {
    displayedMeal () {
      const getMinMeal = (categories) => {
        let minPrice = Infinity
        let minMeal = null
        categories.forEach(cat => {
          cat.meals.forEach(meal => {
            const mealPrice = getPrice({ meal, starRating: this.result.stars, fees: this.fees })
            if (mealPrice < minPrice) {
              minPrice = mealPrice
              minMeal = meal
            }
          })
        })
        return minMeal
      }

      if (this.result.packages) {
        let minMeal = null
        let minPrice = Infinity
        this.result.packages.forEach(pack => {
          const categoryMeal = getMinMeal(pack.categories)
          if (categoryMeal) {
            const mealPrice = getPrice({ meal: categoryMeal, starRating: this.result.stars, fees: this.fees })
            if (mealPrice < minPrice) {
              minPrice = mealPrice
              minMeal = categoryMeal
            }
          }
        })
        return minMeal
      }

      return getMinMeal(this.result.categories)
    },
    starsIsNumber () {
      return Number.isInteger(this.result.stars)
    },
    status () {
      let isAvl = false
      let isNa = true

      const categoriesMap = data => {
        data.categories.map(cat => {
          if (cat.hotelIsAvailable && !cat.hotelIsBlackedOut) isAvl = true
          if (!cat.hotelIsBlackedOut) isNa = false
        })
      }

      if (this.result.packages) {
        this.result.packages.map(pack => {
          categoriesMap(pack)
        })
      } else {
        categoriesMap(this.result)
      }

      if (isAvl) return 'AVL'
      else if (isNa) return 'N/A'
      else return 'RQ'
    }
  }
}
</script>

<style lang="css">
  #lightbox .modal-content,
  #lightbox .modal-content .card {
    background:rgba(255,25,255,0);
    border: none;
  }
  .btn-lightbox{
    border:2px solid #fff;
  }
</style>
